import React, { useState, useEffect } from 'react';
import { Box, Button, IconButton, InputAdornment, FormControl, CssBaseline, CircularProgress, Typography, Grid } from '@material-ui/core';
import { useStyles, CutomOutlinedInput, CustomInputLabel } from './styles';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { updatePassword, getMyProfile } from '../../../actions';
import Cookies from 'js-cookie';
import { decrypt, encrypt } from '../../../helpers/encrypt';
import { useHistory } from 'react-router-dom';
import { signOut, renderDefaultMsg, getAppSource, getUserType } from '../../../helpers';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Switch } from '../CommunicationPreferences/Switch';
import { MfaConfirmation } from '../MfaConfirmation';
import mfa from '../../../assets/Profile/mfa.svg';

export const ChangePassword = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [isProcessPassword, setIsProcessPassword] = useState(false)
  const [isOldPassword, setIsOldPassword] = useState(false)
  const [inputOldPassword, setInputOldPassword] = useState('')
  const [showOldPassword, setShowOldPassword] = useState(false)
  const [inputNewPassword, setInputNewPassword] = useState('')
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [inputConfirmPassword, setInputConfirmPassword] = useState('')
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [isNewPasswordBox, setIsNewPasswordBox] = useState(false)
  const [validNewPassword, setValidNewPassword] = useState({
    isLengthPass: false,
    isLowercasePass: false,
    isUppercasePass: false,
    isNumberPass: false,
    isSpecialCharacterPass: false
  })
  const [isConfirmPasswordBox, setIsConfirmPasswordBox] = useState(false)
  const [isPasswordMatched, setIsPasswordMatched] = useState(false)
  const [accordionStatus, setAccordionStatus] = useState(true);
  const [accordionPwdStatus, setAccordionPwdStatus] = useState(true);
  const [isMFA, setIsMFA] = useState(props.userDetail.isMFA);
  const [successMsg, setSuccessMsg] = useState(false)
  const [mfaConfirmation, setMfaConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);

   useEffect(() => {
      if (props.accountNumber) {
         getUserDetail()
      }
    }, []);

  const getUserDetail = async () => {
    setLoading(true)
    const requestData = {
      "accountNumber": props.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    }
    const result = await getMyProfile(requestData)
    if (result) {
      setLoading(false)
      const { lstResponseStatus } = result
      if (result && (lstResponseStatus[0].statusCode === "0" || lstResponseStatus[0].statusCode === 0)) {
        setIsMFA(result.isMFA)
      }
    } else {
      setLoading(false)
    } 
  }

  const handleChange = (prop) => (event) => {
    if (prop === 'inputOldPassword') {
      setInputOldPassword(event.target.value)
    } else if (prop === 'inputNewPassword') {
      let matchStatus = inputConfirmPassword === event.target.value ? true : false
      passwordFormate(event.target.value)
      setInputNewPassword(event.target.value)
      setIsPasswordMatched(matchStatus)
      if (inputConfirmPassword !== '') {
        setIsConfirmPasswordBox(!matchStatus)
      }
    } else if (prop === 'inputConfirmPassword') {
      let matchStatus = inputNewPassword === event.target.value ? true : false
      setInputConfirmPassword(event.target.value)
      setIsConfirmPasswordBox(!matchStatus)
      setIsPasswordMatched(matchStatus)
    }
  }

  const passwordFormate = (str) => {
    let isLowercasePass = false
    let isUppercasePass = false
    let isNumberPass = false
    let isSpecialCharacterPass = false
    let isLengthPass = false
    let strengthSizePass = 0

    if (/\d/.test(str)) {
      isNumberPass = true
      strengthSizePass++
    }

    if (/[A-Z]/.test(str)) {
      isUppercasePass = true
      strengthSizePass++
    }
    if (/[a-z]/.test(str)) {
      isLowercasePass = true
      strengthSizePass++
    }
    if (str.length >= 8 && str.length <= 20) {
      isLengthPass = true
      strengthSizePass++
    }

    if (/[~`@!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(str)) {
      isSpecialCharacterPass = true
      strengthSizePass++
    }

    let isNewPasswordBox = strengthSizePass === 5 ? false : true
    setValidNewPassword({
      isLengthPass,
      isLowercasePass,
      isUppercasePass,
      isNumberPass,
      isSpecialCharacterPass
    })
    setIsNewPasswordBox(isNewPasswordBox)
  }

  const validClass = (isValid) => {
    if (isValid) {
      return `${classes.validationText} ${classes.validationSuccess}`
    } else {
      return `${classes.validationText} ${classes.validationError}`
    }
  }

  const handleSubmit = async () => {
    if (inputOldPassword !== '' && isNewPasswordBox === false && isPasswordMatched) {
      const requestData = {
        "userName": "",
        "oldPassword": encrypt(inputOldPassword),
        "newPassword": encrypt(inputNewPassword),
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get('publicIp'),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType()
      }
      setIsProcessPassword(true)
      setErrorMessage('')
      setSuccessMessage('')
      const result = await updatePassword(requestData);
      if (result) {
        const { lstResponseStatus } = result
        if (result && (lstResponseStatus[0].statusCode === "0" || lstResponseStatus[0].statusCode === 0)) {
          signOut(() => history.push('/SignIn?password=changed'))
        } else {
          setIsProcessPassword(false)
          setSuccessMessage('')
          setErrorMessage(lstResponseStatus[0].statusDesc)
        }
      } else {
        setIsProcessPassword(false)
        setSuccessMessage('')
        setErrorMessage(renderDefaultMsg('400'))
      }
    }
  }

  const handleSaveChanges = (status) => {
     setMfaConfirmation(false)
      if (status) {
        setIsMFA(!isMFA)
      } else {
        setIsMFA(props.userDetail.isMFA)
      }
  }

  const handleMFA = () => {
    setMfaConfirmation(true)
  }

  if (loading) {
    return (
      <Box className={classes.loadingRoot}>
        <CircularProgress />
      </Box>
    )
  } 

  const disabledBtn = inputOldPassword !== '' && isNewPasswordBox === false && isPasswordMatched
  return (
    <CssBaseline>
      <Box className={`${classes.consentAccordian} ${'mfa'}`}>
      <Accordion elevation={0} className={classes.transactionText} expanded={accordionStatus} onChange={() => setAccordionStatus(!accordionStatus)}>
          <AccordionSummary
            expandIcon={ <ExpandMoreIcon />}
            aria-controls={`panelc-content`}
            id={`panelc-header`}
            style={{ backgroundColor: '#F5F5F5',
              border: '1px solid #B4B4B4', borderRadius: '6px 6px 2px 2px'}}
            >
            <Box className={classes.confirmationStatus}>
              <span className={classes.type}>Security</span> 
            </Box>
          </AccordionSummary>

          <AccordionDetails style={{ border: '1px solid #B4B4B4', borderRadius: '2px 2px 6px 6px', display: 'block'}}>
            
          <Box mb={1}>
                  <Grid container direction="row" justifyContent="space-between" alignItems="center" >
                    <Grid item xs={9} sm={9} md={11}> 
                    <Box style={{display: 'flex'}}>
                    <img src={mfa} alt="icon" style={{ width: '18px', height: '18px', marginRight: '10px'}}/>
                    <Typography className={classes.title}>Multi-Factor Authentication: Use OTP for Secure Login</Typography>
                     </Box>
                    <Box style={{marginTop: '12px'}}>
                     <Typography className={classes.description}>Add extra protection to your account with Multi-Factor Authentication (MFA).</Typography>
                     <Typography className={classes.description}>A One-Time Passcode (OTP) will be sent to your registered email <b>{decrypt(props.userDetail.emailID)}</b> each time you sign in.</Typography>
                     </Box>
                     </Grid>
                    <Grid item xs={3} sm={3} md={1} className={classes.textRight}>
                      <Switch
                        index={0}
                        status={isMFA}
                        handleSwitch={handleMFA}
                        switchName={"isMfa"}
                        ></Switch>
                    </Grid>
                  </Grid>
                   {errorMessage ? (<Box><Typography className={classes.errorMessage}>{errorMessage}</Typography></Box>) : null}
                   {successMsg && <p className={classes.successMsg}>Changes saved successfully.</p>}

                </Box>
        </AccordionDetails>
        </Accordion>
      </Box>

      <Accordion elevation={0} className={classes.transactionText} expanded={accordionPwdStatus} onChange={() => setAccordionPwdStatus(!accordionPwdStatus)}>
          <AccordionSummary
            expandIcon={ <ExpandMoreIcon />}
            aria-controls={`panelc-content`}
            id={`panelc-header`}
            style={{ backgroundColor: '#F5F5F5',
              border: '1px solid #B4B4B4', borderRadius: '6px 6px 2px 2px'}}
            >
            <Box className={classes.confirmationStatus}>
              <span className={classes.type}>Password</span> 
            </Box>
          </AccordionSummary>

          <AccordionDetails style={{ border: '1px solid #B4B4B4', borderRadius: '2px 2px 6px 6px', display: 'block'}}>
          <Box className={classes.formContainer}>
            <form noValidate autoComplete="off" >
              <Box className={classes.inputContainer}>
                <FormControl variant="outlined" >
                  <CustomInputLabel className={classes.labelStyle} htmlFor="outlined-old-password">Old Password</CustomInputLabel>
                  <CutomOutlinedInput
                    id="outlined-old-password"
                    type={showOldPassword ? 'text' : 'password'}
                    value={inputOldPassword}
                    onChange={handleChange('inputOldPassword')}
                    labelWidth={200}
                    inputProps={{
                      className: classes.inputStyle,
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowOldPassword(!showOldPassword)}
                          edge="end"
                          tabIndex="-1"
                        >
                          {showOldPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {isOldPassword ? (
                  <Box border={1} mb={2} p={4} className={classes.validationBox}>
                    <Box pb={2}>
                      <Typography className={classes.validationTitle}>Old Password Requirements</Typography>
                    </Box>
                    <Typography className={validClass(!isOldPassword)}>Old Password Required</Typography>
                  </Box>) : null}
              </Box>

              {/* New Password */}
              <Box className={classes.inputContainer}>
                <FormControl variant="outlined" >
                  <CustomInputLabel className={classes.labelStyle} htmlFor="outlined-new-password">New Password</CustomInputLabel>
                  <CutomOutlinedInput
                    id="outlined-new-password"
                    type={showNewPassword ? 'text' : 'password'}
                    value={inputNewPassword}
                    onChange={handleChange('inputNewPassword')}
                    labelWidth={200}
                    inputProps={{
                      className: classes.inputStyle,
                      maxLength: 20
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          edge="end"
                          tabIndex="-1"
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                {isNewPasswordBox ? (
                  <Box border={1} mb={2} p={4} className={classes.validationBox}>
                    <Box pb={2}>
                      <Typography className={classes.validationTitle}>Password Requirements</Typography>
                    </Box>
                    <Typography className={validClass(validNewPassword.isLengthPass)}>Password must be between 8 and 20 characters long</Typography>
                    <Typography className={validClass(validNewPassword.isLowercasePass)}>Must contain atleast 1 lower case letter [a-z]</Typography>
                    <Typography className={validClass(validNewPassword.isUppercasePass)}>Must also contain 1 upper case letter [A-Z]</Typography>
                    <Typography className={validClass(validNewPassword.isNumberPass)}>Must also contain 1 digit [0-9]</Typography>
                    <Typography className={validClass(validNewPassword.isSpecialCharacterPass)}>Must also contain 1 special character (#, %, $, !, &, @)</Typography>
                  </Box>) : null}
              </Box>

              {/* Confirm Password */}
              <Box className={classes.inputContainer}>
                <FormControl variant="outlined" >
                  <CustomInputLabel className={classes.labelStyle} htmlFor="outlined-new-password">Confirm Password</CustomInputLabel>
                  <CutomOutlinedInput
                    id="outlined-confirm-password"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={inputConfirmPassword}
                    onChange={handleChange('inputConfirmPassword')}
                    labelWidth={200}
                    inputProps={{
                      className: classes.inputStyle,
                      maxLength: 20
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                          tabIndex="-1"
                        >
                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />

                </FormControl>
                {isConfirmPasswordBox ? (
                  <Box border={1} mb={2} p={4} className={classes.validationBox}>
                    <Box pb={2}>
                      <Typography className={classes.validationTitle}>Confirm Password Requirements</Typography>
                    </Box>
                    <Typography className={validClass(isPasswordMatched)}>Please confirm that the password in both fields match.</Typography>
                  </Box>) : null}
              </Box>
              <Box textAlign="center" pt={3}>
                {successMessage ? (<Box><Typography className={classes.successMessage}>{successMessage}</Typography></Box>) : null}
                {errorMessage ? (<Box><Typography className={classes.errorMessage}>{errorMessage}</Typography></Box>) : null}
                {isProcessPassword ? (<Button className={classes.btn} disabled={true} variant="contained"><CircularProgress /></Button>) : (
                  <Button
                    onClick={() => handleSubmit()}
                    className={classes.btn}
                    variant="contained"
                    color="primary"
                    // disabled={!disabledBtn}
                    >
                    SUBMIT</Button>)}
              </Box>
            </form>
          </Box>
        </AccordionDetails>
      </Accordion> 
      <MfaConfirmation open={mfaConfirmation} status={!isMFA} handleOk={handleSaveChanges} handleClose={() => setMfaConfirmation(false)} emailID={decrypt(props.userDetail.emailID)} type="mlw" accountNumber={props.userDetail.accountNumber} isMFA={isMFA}/>

    </CssBaseline>
  )
}
